import React from 'react';
import PropTypes from 'prop-types';
import ExpandableList from "../ExpandableList";
import { tracksColors } from "../../../../config/styles";
import LiftCountIcon from "../../Icons/LiftCountIcon";
import LiftBugilIcon from "../../Icons/LiftBugilIcon";
import { t } from "../../../../lang/trans";
import { sortLiftsArray } from "../../../../helpers/map";

const mockTitles = {
   6: t('шестикрісельний'),
   4: t('чотирикрісельний'),
   3: t('трикрісельний'),
   2: t('двокрісельний'),
   bugil: t('бугельний витяг')
};

const getColor = status => {
   if (typeof tracksColors[status] !== 'undefined')
      return tracksColors[status];
};

const LegendLiftsInfo = ({ onToggle, lifts, isOpen, count, isBugil, liftsCount, onClickOnLift }) => {
   const titleCount = liftsCount ? ' ' + liftsCount.open + '/' + liftsCount.count : '';
   const blockTitle = (isBugil ? mockTitles.bugil : mockTitles[count]) + titleCount;

   return <ExpandableList
      title={blockTitle}
      iconComponent={isBugil ? <LiftBugilIcon/> : <LiftCountIcon count={count}/>}
      isOpen={isOpen}
      onToggle={onToggle}
   >
      {/*{liftData.blockTitle && (<div className="legend-tracks-list-info-text">{liftData.blockTitle}</div>)}*/}

      <ul className={`legend-tracks-list legend-tracks-list--closed`}>
         {sortLiftsArray(lifts).map((lift, index) => (
            <li
               key={index}
               style={{ color: getColor(lift.isOpen ? 'open' : 'closed') }}
               data-bordercolor={getColor(lift.isOpen ? 'open' : 'closed')}
               onClick={() => onClickOnLift(lift.info.name)}
            >
               {(lift && lift.info) && lift.info.name}
            </li>
         ))}
      </ul>
   </ExpandableList>
};

LegendLiftsInfo.defaultProps = {
   lifts: []
};

LegendLiftsInfo.propTypes = {
   isOpen: PropTypes.bool,
   lifts: PropTypes.array,
   onToggle: PropTypes.func,
   liftsCount: PropTypes.object,
   onClickOnLift: PropTypes.func
};

export default LegendLiftsInfo;
